module.exports = __webpack_public_path__ + "img/logo-mercadon-desktop.752f895e.svg";